<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="20">
            <md-button class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousExection">&laquo; Back</md-button>
          </md-layout>
        </md-layout>

        <hr class="hr-s">

        <!-- <div v-if="consoMultipleShipperTable.length<=0"> -->
        <!-- <div v-if=" airFreightModal.shipperFreightId==''">
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="10">
              <label style="margin-top:15px">
                <u>Job Type</u>
              </label>
            </md-layout>

            <md-layout
              v-for="(segmentNameArray, index) in showSegmentArray"
              :key="index"
              :md-flex="segmentNameArray.flex"
            >
              <md-checkbox
                v-model="AirFreightMain.jobType[index]"
                class="md-primary"
                :md-value="segmentNameArray.value"
                :name="'jobType'+(index+1)"
                :id="'jobType'+(index+1)"
                @change="jobTypeSelect(segmentNameArray.value,index)"
              >{{segmentNameArray.show}}</md-checkbox>
            </md-layout>
          </md-layout>

          <hr class="hr-border">

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="shipmentType">Shipping Type</label>

              <model-list-select
                :list="shipmentTypeList"
                v-model="AirFreightMain.shipmentType"
                option-value="shipmentTypeVal"
                option-text="shipmentTypeText"
                placeholder="Select Shipment Type"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
              <label for="transportType">Export / Import</label>

              <model-list-select
                :list="transportTypeList"
                v-model="AirFreightMain.transportType"
                option-value="transportTypeVal"
                option-text="transportTypeText"
                placeholder="Select Transport Type"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="airportDeparture">Departure Airport</label>

              <model-list-select
                :list="allLocationList"
                v-model="AirFreightMain.airportDeparture"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Airport"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="airportDestination">Destination Airport</label>

              <model-list-select
                :list="allLocationList"
                v-model="AirFreightMain.airportDestination"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Airport"
              ></model-list-select>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="airFFType">FF Activity Type</label>

              <model-list-select
                :list="containerInfoList"
                v-model="AirFreightMain.airFFType"
                option-value="containerInfoVal"
                option-text="containerInfoText"
                placeholder="Select FF Activity"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="shipmentExecution">Shipment Execution</label>

              <model-list-select
                :list="shipmentExectionList"
                v-model="AirFreightMain.shipmentExecution"
                option-value="shipmentExectionVal"
                option-text="shipmentExectionTxt"
                placeholder="Select Shipment Execution"
              ></model-list-select>
            </md-layout>
          </md-layout>
        </div>-->
        <!-- 







        <div v-if="consoMultipleShipperTable.length<=0 || airFreightModal.shipperFreightId!=''">
          <md-layout md-gutter v-if="AirFreightMain.airFFType=='fclConsolidation'">
            <hr class="hr-border">

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
        Other Services 
              <h3 style="margin-top:16px">
                <u>Shipper Details</u>
              </h3>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="clientId">Existing Client Name</label>

              <model-list-select
                :list="clientList"
                id="clientNamenew"
                v-model="airFreightModal.clientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Existing Client Name"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="stuffingType">Cargo Received At</label>

              <model-list-select
                :list="stuffingTypeList"
                v-model="airFreightModal.cargoReceivedAt"
                option-value="stuffingTypeVal"
                option-text="stuffingTypeText"
                placeholder="Select Received At"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="shipmentType">Source Of Booking</label>

               bookingSource is for source of booking 
              <model-list-select
                :list="bookingSourceList"
                v-model="airFreightModal.bookingSource"
                option-value="bookingSourceVal"
                option-text="bookingSourceText"
                placeholder="Select Source Of Booking "
              ></model-list-select>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
              <h4 style="margin:0px" class="showMoreData" @click="addNew">Add New Client</h4>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25" v-if="airFreightModal.bookingSource=='Destination'">
              <label for="agentName">Agent Name</label>

              <model-list-select
                :list="agentNameList"
                v-model="airFreightModal.agentName"
                option-value="agntColoaderId"
                option-text="agentName"
                placeholder="Select Agent Name"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="25" v-if="airFreightModal.bookingSource=='Origin'">
              <label for="sourceOriginclientId">Client Name</label>

              <model-list-select
                :list="clientList"
                id="clientNamenew"
                v-model="airFreightModal.sourceOriginclientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Client Name"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25" v-if="airFreightModal.bookingSource=='Destination'">
              <md-layout md-flex="100">
                <label>Buyer Name</label>

                <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer" v-model="airFreightModal.buyer"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="25" v-if="airFreightModal.bookingSource=='Origin'">
              <md-layout md-flex="100">
                <label>Enter Buying House</label>

                <b-form-input :formatter="capitalizeAll" id="buyingHouse" name="buyingHouse" v-model="airFreightModal.buyingHouse"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="30" v-if="airFreightModal.bookingSource=='Origin'">
              <md-layout md-flex="100">
                <label>Other Specify</label>

                <b-form-input :formatter="capitalizeAll"
                  id="otherSpecify"
                  name="otherSpecify"
                  v-model="airFreightModal.otherSpecify"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
             <h4 style="padding:0px;margin:0px"></h4> 
              <label for="ccType">CC Type</label>

              <model-list-select
                :list="cctypeList"
                v-model="airFreightModal.ccType"
                option-value="ccTypeVal"
                option-text="ccTypeTxt"
                placeholder="Select CC Type"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20" v-if="airFreightModal.ccType=='Outsourced'">
              <md-layout md-flex="100">
                <label>CHA Name</label>

                <b-form-input :formatter="capitalizeAll" id="ccCha" name="ccCha" v-model="airFreightModal.ccCha"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="deliveryMode">Destination Delivery Mode</label>

              <model-list-select
                :list="deliveryModeList"
                v-model="airFreightModal.deliveryMode"
                option-value="deliveryModeVal"
                option-text="deliveryModeText"
                placeholder="Select Delivery Mode"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20" v-if="airFreightModal.deliveryMode=='Door'">
              <label for="doorFpod">Final Place of Delivery</label>

              <model-list-select
                :list="allLocationList"
                v-model="airFreightModal.doorFpod"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select FPOD"
              ></model-list-select>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>

              <model-list-select
                :list="deliveryTermsList"
                v-model="airFreightModal.deliveryTerms"
                option-value="deliveryTermsVal"
                option-text="deliveryTermsText"
                placeholder="Select Delivery Terms"
              ></model-list-select>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
           <h4 style="padding:0px;margin:0px"></h4> 
              <label for="autoCommodity">Commodity</label>

              <model-list-select
                :list="commodityList"
                v-model="airFreightModal.commodityId"
                option-value="commodityId"
                option-text="itemDescription"
                placeholder="Select Commodity"
              ></model-list-select>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label for="commodityType">Commodity Type</label>

                <b-form-input :formatter="capitalizeAll"
                  id="commodityType"
                  name="commodityType"
                  disabled
                  v-model="airFreightModal.commodityType"
                ></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <label for="itemDescription">Item Description</label>

                <b-form-input :formatter="capitalizeAll"
                  id="itemDescription"
                  name="itemDescription"
                  disabled
                  v-model="airFreightModal.itemDescription"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <md-layout md-gutter v-if="airFreightModal.commodityType=='Hazardous'">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>IMDG Class</label>

                <b-form-input :formatter="capitalizeAll" id="IMDGClass" name="IMDGClass" v-model="airFreightModal.IMDGClass"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>UN Number</label>

                <b-form-input :formatter="capitalizeAll" id="UNNumber" name="UNNumber" v-model="airFreightModal.UNNumber"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Packing Code</label>

                <b-form-input :formatter="capitalizeAll" id="packingCode" name="packingCode" v-model="airFreightModal.packingCode"></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <md-layout md-gutter v-if="airFreightModal.commodityType=='Reefer'">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Temperature Req(Degree Celsius)</label>

                <b-form-input :formatter="capitalizeAll"
                  id="temperatureRequired"
                  name="temperatureRequired"
                  v-model="airFreightModal.temperatureRequired"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <md-layout md-gutter v-if="airFreightModal.commodityType=='Others'">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Specific Detail if any..!</label>

                <b-form-input :formatter="capitalizeAll"
                  id="otherComodity"
                  name="otherComodity"
                  v-model="airFreightModal.otherComodity"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="15">
            Other Services 
              <label style="margin-top:16px">
                <u>Additional Task</u>
              </label>
            </md-layout>
         


             <md-layout
            v-for="(otherServiceNameArray, index) in showOtherServiceArray"
            :key="index"
            :md-flex="otherServiceNameArray.flex"
          >
            <md-checkbox
              v-model="airFreightModal.otherServices[index]"
              class="md-primary"
              :md-value="otherServiceNameArray.value"
              :name="'otherServices'+(index+1)"
              :id="'otherServices'+(index+1)"
              @change="otherServiceNameArraySelect(otherServiceNameArray.value,index)"
            >{{otherServiceNameArray.show}}</md-checkbox>
          </md-layout>
          </md-layout>

          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <md-layout md-flex="100">
                <label for="additionalMoreTask">More Additional Task</label>

                <md-select
                  name="additionalMoreTask"
                  id="additionalMoreTask"
                  multiple
                  v-model="airFreightModal.additionalMoreTask"
                  @change="showMultiple"
                >
                  <md-option
                    v-for="(AdditionalMoreArray,index) in showAdditionalMoreTaskArray"
                    :key="index"
                    :value="AdditionalMoreArray"
                  >{{AdditionalMoreArray.show}}</md-option>
                </md-select>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

      
            <md-layout md-flex="35" v-if="showAdd">
              <md-layout md-flex="100">
                <label>Specify Additional Task</label>

                <b-form-input :formatter="capitalizeAll"
                  id="specificAdditionalTask"
                  name="specificAdditionalTask"
                  v-model="airFreightModal.specificAdditionalTask"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <hr class="hr-borer">

          <md-layout md-gutter>
            <md-layout md-flex="40"></md-layout>

            <md-layout md-flex="35">
              <md-button
                class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                id="addButtonLoaderMid"
                @click="addMainWithShipper"
              >{{airFreightModal.shipperFreightId != ""?"Edit":"Add"}}</md-button>

              <md-spinner md-indeterminate id="loaderMid" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
        </div>-->
        <div v-if="allShipperData.length>0">
          <hr class="hr-borer">

          <md-card>
            <md-card-content>
              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <!-- Other Services -->
                  <h3 style="margin-top:16px">
                    <u>Package Details</u>
                  </h3>
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="35">
                  <label for="sourceOriginclientId">Client Name</label>

                  <model-list-select :list="packageClientList" id="clientNamenew"
                    v-model="airPackageModal.shipperFreightId" option-value="shipperFreightId" option-text="clientName"
                    placeholder="Select Client Name"
                    :isDisabled="airPackageModal.cargoId!=''?true:false"></model-list-select>

                  <span class="error"
                    v-if="!airPackageModal.shipperFreightId">{{packageErrorList.shipperFreightId}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter style="margin-top:10px" v-if="airPackageModal.shipperFreightId!=''">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Cargo Gross Weight</label>

                    <b-form-input :formatter="capitalizeAll" id="cargoGrossWeight" name="cargoGrossWeight" type="number"
                      v-model="airPackageModal.cargoGrossWeight" @keyup="VolumeWeightBySysAmount"></b-form-input>
                  </md-layout>

                  <span class="error"
                    v-if="!airPackageModal.cargoGrossWeight">{{packageErrorList.cargoGrossWeight}}</span>
                </md-layout>

                <md-layout md-flex="10">
                  <label for="deliveryTerms">Unit</label>

                  <model-list-select :list="CargowgtUnitList" v-model="airPackageModal.CargowgtUnit"
                    option-value="CargowgtUnitVal" option-text="CargowgtUnitText"
                    placeholder="Select Unit"></model-list-select>

                  <!-- <md-layout md-flex="100">
                    <label for="CargowgtUnit">Unit</label>

                    <md-select
                      name="CargowgtUnit"
                      id="CargowgtUnit"
                      v-model="airPackageModal.CargowgtUnit"
                    >
                      <md-option value="Kg">Kg</md-option>

                      <md-option value="LBS">LBS</md-option>
                    </md-select>
                  </md-layout>-->
                  <span class="error" v-if="!airPackageModal.CargowgtUnit">{{packageErrorList.CargowgtUnit}}</span>
                </md-layout>

                <md-layout md-flex="10"></md-layout>

                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Volume Weight of Cargo</label>

                    <b-form-input :formatter="capitalizeAll" id="cargoVolumeWeight" name="cargoVolumeWeight"
                      v-model="airPackageModal.cargoVolumeWeight" type="number" disabled></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter v-if="packageDetails.length>0 && airPackageModal.shipperFreightId!=''">
                <md-layout md-flex="70"></md-layout>

                <md-layout md-flex="30">
                  <h4 class="showMoreData" @click="showMoreContainer">Click here to {{showPackage==true?"Hide":"Add"}}
                    Package Details</h4>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr" v-if="packageDetails.length==0 || showPackage==true">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>No. Of Packages</label>

                    <b-form-input :formatter="capitalizeAll" id="noOfPackage" name="noOfPackage"
                      v-model="airPackageModal.noOfPackage" @keyup="VolumeWeightCargoAmount"
                      type="number"></b-form-input>
                  </md-layout>

                  <span class="error" v-if="!airPackageModal.noOfPackage">{{packageErrorList.noOfPackage}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter style="margin-top:10px" v-if="packageDetails.length==0 || showPackage==true">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Length</label>

                    <b-form-input :formatter="capitalizeAll" id="packageLength" name="packageLength"
                      v-model="airPackageModal.packageLength" @keyup="VolumeWeightCargoAmount"
                      type="number"></b-form-input>
                  </md-layout>

                  <span class="error" v-if="!airPackageModal.packageLength">{{packageErrorList.packageLength}}</span>
                </md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Width</label>

                    <b-form-input :formatter="capitalizeAll" id="packageWidth" name="packageWidth"
                      v-model="airPackageModal.packageWidth" @keyup="VolumeWeightCargoAmount"
                      type="number"></b-form-input>
                  </md-layout>

                  <span class="error" v-if="!airPackageModal.packageWidth">{{packageErrorList.packageWidth}}</span>
                </md-layout>

                <md-layout md-flex="10">
                  <md-layout md-flex="100">
                    <label>Height</label>

                    <b-form-input :formatter="capitalizeAll" id="packageHeight" name="packageHeight"
                      v-model="airPackageModal.packageHeight" @keyup="VolumeWeightCargoAmount"
                      type="number"></b-form-input>
                  </md-layout>

                  <span class="error" v-if="!airPackageModal.packageHeight">{{packageErrorList.packageHeight}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="10">
                  <md-input-container>
                    <label for="packageUnit">Unit</label>

                    <md-select name="packageUnit" id="packageUnit" v-model="airPackageModal.packageUnit"
                      @selected="VolumeWeightCargoAmount">
                      <md-option value="Cm">Cm</md-option>

                      <md-option value="Inch">Inch</md-option>
                    </md-select>
                  </md-input-container>

                  <span class="error" v-if="!airPackageModal.packageUnit">{{packageErrorList.packageUnit}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Package Volume</label>

                    <b-form-input :formatter="capitalizeAll" id="packageVolume" name="packageVolume"
                      v-model="airPackageModal.packageVolume" disabled></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-button style="margin-top:16px" class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                  id="addButtonLoaderpackage" @click="addPackage">{{airPackageModal.cargoId != ""?"Edit":"Add"}}
                  Package</md-button>

                <md-spinner md-indeterminate id="loaderpackage" style="display:none"></md-spinner>
              </md-layout>

              <hr class="hr-border" v-if="airPackageModal.shipperFreightId!='' && packageDetails.length>0">

              <md-layout md-gutter v-if="airPackageModal.shipperFreightId!='' && packageDetails.length>0">
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Chargeable Volume Weight By Airline</label>

                    <b-form-input :formatter="capitalizeAll" id="chargeVolWgtAir" name="chargeVolWgtAir"
                      v-model="airPackageModal.chargeVolWgtAir" @keyup="FinalVolumeWeightAmount"
                      type="number"></b-form-input>
                  </md-layout>

                  <span class="error"
                    v-if="!airPackageModal.chargeVolWgtAir">{{packageErrorList.chargeVolWgtAir}}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Chargeable Volume Weight By System</label>

                    <b-form-input :formatter="capitalizeAll" id="chargeVolWgtSys" name="chargeVolWgtSys"
                      v-model="airPackageModal.chargeVolWgtSys" disabled></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Final Chargeable Weight</label>

                    <b-form-input :formatter="capitalizeAll" id="finalChargableWeight" name="finalChargableWeight"
                      v-model="airPackageModal.finalChargableWeight" disabled></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <hr class="hr-border" v-if="showPackage==false  && airPackageModal.shipperFreightId!=''">

              <md-layout md-gutter
                v-if="(airPackageModal.shipperFreightId!='' && packageDetails.length>0) || showPackage==true">
                <md-layout md-flex="40"></md-layout>

                <md-layout md-flex="25">
                  <md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
                    id="addButtonLoaderMultiple" v-if="showPackage==false" @click="updateCargo">Update</md-button>

                  <md-spinner md-indeterminate id="loaderMultiple" style="display:none"></md-spinner>
                </md-layout>
              </md-layout>

              <hr class="hr-s" v-if="packageDetails.length>0">

              <div class="box" v-if="packageDetails.length>0">
                <div class="box-header">
                  <h3 class="box-title">
                    <u>Package Details</u>
                  </h3>

                  <span class="pull-right" style="color:blue;font-size:17px;margin-right:5%"
                    v-if="airPackageModal.shipperFreightId!=''">Total Volume Weight of Cargo =
                    {{totalPackageVolume}}</span>

                  <span class="pull-right" style="color:blue;font-size:17px;margin-right:5%"
                    v-if="airPackageModal.shipperFreightId!=''">Total No. of Package = {{totalPackage}}</span>
                </div>

                <!-- /.box-header -->
                <div class="box-body">
                  <table id="portLocationNew" class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr.no</th>

                        <th>Client Name</th>

                        <th>No.of Package</th>

                        <th>Package Length</th>

                        <th>Package Width</th>

                        <th>Package Height</th>

                        <th>Unit</th>

                        <th>Package Volume</th>
                        <th>Delete</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item1,index) in packageDetails" :key="index">
                        <td>{{index+1}}</td>

                        <td class="showMoreData" @click="viewEditPackage(item1)">{{item1.clientName}}</td>

                        <td>{{item1.noOfPackage}}</td>

                        <td>{{item1.packageLength}}</td>

                        <td>{{item1.packageWidth}}</td>

                        <td>{{item1.packageHeight}}</td>

                        <td>{{item1.packageUnit}}</td>

                        <td>{{item1.packageVolume}}</td>
                        <td>
                          <md-button class="md-icon-button md-raised md-dense" @click="DeleteList(item1.cargoId)">
                            <md-icon>delete_sweep</md-icon>
                          </md-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- /.box-body -->
              </div>
            </md-card-content>
          </md-card>

          <hr class="hr-border">

          <md-layout md-gutter v-if="openShipper!=true">
            <md-layout md-flex="40"></md-layout>

            <md-layout md-flex="35">
              <md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per" id="addButtonLoaderpro"
                @click="proceedBooking">Proceed To Booking Order</md-button>

              <md-spinner md-indeterminate id="loaderpro" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopError"></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"
      @close="goToBookingPage"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";

import axios from "axios";

import { ModelListSelect } from "vue-search-select";

import Loading from "vue-loading-overlay";

import "vue-loading-overlay/dist/vue-loading.css";

import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";

import { globalPermissionStatus } from "../../helper/collection";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",

        "/freightForwarding/driverffExportFcl"
      );

      this.getServicesData();

      if (globalPermissionStatus("driverMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",

          globalPermissionStatus("driverMaster")
        );

        this.getData();
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }

    // this.vehicle();
  },

  watch: {
    airFreightModal: {
      handler: function(newVal, oldVal) {
        console.log("Here Change obj", newVal, oldVal);

        if (newVal.commodityId != "") {
          let arrayFilter = this.getCommodityData.filter(x => {
            return x.commodityId == newVal.commodityId;
          })[0];

          this.CommodityCallback(arrayFilter);
        }

        if (this.airFreightModal.clientId != "") {
          let checkAlready = this.consoMultipleShipperTable.filter(x => {
            return x.clientId == this.airFreightModal.clientId;
          });

          if (
            checkAlready.length > 0 &&
            this.airFreightModal.shipperFreightId == ""
          ) {
            this.alert.content = checkAlready[0].clientName + " Already Exist";
            this.$refs["addPopError"].open();
            this.airFreightModal.clientId = "";
          } else {
            let arrayClentId = this.getCLientData.filter(x => {
              return x.clientId == this.airFreightModal.clientId;
            });

            if (arrayClentId.length > 0) {
              this.airFreightModal.clientName = arrayClentId[0].clientName;
            }
          }
        }
      },
      deep: true
    },
    airPackageModal: {
      handler: function(newVal, oldVal) {
        console.log("Here Change obj", newVal, oldVal);

        this.allFinalWeight();
      },

      deep: true
    }
  },

  data() {
    return {
      isLoading: false,

      transportTypeList: [
        {
          transportTypeVal: "Export",

          transportTypeText: "Export"
        },

        {
          transportTypeVal: "Import",

          transportTypeText: "Import"
        }
      ],

      departureAirportListName: [],

      stuffingTypeList: [
        {
          stuffingTypeVal: "airport",

          stuffingTypeText: "Airport"
        },

        {
          stuffingTypeVal: "warehouse",

          stuffingTypeText: "Warehouse"
        }
      ],

      cctypeList: [
        {
          ccTypeVal: "Own",

          ccTypeTxt: "Own"
        },

        {
          ccTypeVal: "Outsourced",

          ccTypeTxt: "Outsourced"
        }
      ],

      shipmentExectionList: [
        {
          shipmentExectionVal: "AirFreight",

          shipmentExectionTxt: "Air Freight"
        },

        {
          shipmentExectionVal: "Courier",

          shipmentExectionTxt: "Courier"
        }
      ],

      containerInfoList: [
        {
          containerInfoVal: "fclNormal",

          containerInfoText: "FCL Normal"
        },

        {
          containerInfoVal: "fclConsolidation",

          containerInfoText: "FCL Consolidation"
        }
      ],

      deliveryModeList: [
        {
          deliveryModeVal: "upto_AirPort",

          deliveryModeText: "Upto AirPort"
        },

        {
          deliveryModeVal: "Door",

          deliveryModeText: "Door"
        }
      ],

      CargowgtUnitList: [
        {
          CargowgtUnitVal: "Kg",

          CargowgtUnitText: "Kg"
        },

        {
          CargowgtUnitVal: "LBS",

          CargowgtUnitText: "LBS"
        }
      ],
      deliveryTermsList: [
        {
          deliveryTermsVal: "ExWorks",

          deliveryTermsText: "Ex-Works"
        },

        {
          deliveryTermsVal: "DDP",

          deliveryTermsText: "DDP"
        },

        {
          deliveryTermsVal: "DAP",

          deliveryTermsText: "DAP"
        },

        {
          deliveryTermsVal: "DDP",

          deliveryTermsText: "DDP"
        },

        {
          deliveryTermsVal: "FOB_POR",

          deliveryTermsText: "FOB_POR_"
        },

        {
          deliveryTermsVal: "FOB_LoadPort",

          deliveryTermsText: "FOB_LoadPort_"
        },

        {
          deliveryTermsVal: "FCA",

          deliveryTermsText: "FCA"
        },

        {
          deliveryTermsVal: "FAS",

          deliveryTermsText: "DDP"
        },

        {
          deliveryTermsVal: "CFR",

          deliveryTermsText: "CFR"
        },

        {
          deliveryTermsVal: "CIF",

          deliveryTermsText: "CIF"
        },

        {
          deliveryTermsVal: "CIP",

          deliveryTermsText: "CIP"
        },

        {
          deliveryTermsVal: "CPT",

          deliveryTermsText: "CPT"
        },

        {
          deliveryTermsVal: "DAF",

          deliveryTermsText: "DAF"
        },

        {
          deliveryTermsVal: "DES",

          deliveryTermsText: "DES"
        },

        {
          deliveryTermsVal: "DEQ",

          deliveryTermsText: "DEQ"
        }
      ],

      shipmentTypeList: [
        {
          shipmentTypeVal: "Sea_Shipment",

          shipmentTypeText: "Sea Shipment"
        },

        {
          shipmentTypeVal: "Air_Shipment",

          shipmentTypeText: "Air Shipment"
        }
      ],

      pdaDetailsName: [
        {
          pdaDetailsVal: "Pridel",

          pdaDetailsText: "Pridel"
        },

        {
          pdaDetailsVal: "Shipper",

          pdaDetailsText: "Shipper"
        },

        {
          pdaDetailsVal: "Liner",

          pdaDetailsText: "Liner"
        }
      ],

      oceanFreightTermsName: [
        {
          oceanFreightTermsVal: "prepaid",

          oceanFreightTermsText: "Prepaid"
        },

        {
          oceanFreightTermsVal: "collect",

          oceanFreightTermsText: "Collect"
        }
      ],

      prepaidDetailsName: [
        {
          prepaidDetailsVal: "C_F",

          prepaidDetailsText: "C & F"
        },

        {
          prepaidDetailsVal: "CIF",

          prepaidDetailsText: "CIF"
        }
      ],

      collectDetailsName: [
        {
          collectDetailsVal: "Ex_Works",

          collectDetailsText: "Ex Works"
        },

        {
          collectDetailsVal: "FOB_Place_Of_Receipt",

          collectDetailsText: "FOB Place Of Receipt"
        },

        {
          collectDetailsVal: "FOB_Load_Port",

          collectDetailsText: "FOB Load Port"
        }
      ],

      showAdd: false,

      bookingSourceList: [
        {
          bookingSourceVal: "Origin",

          bookingSourceText: "Origin"
        },

        {
          bookingSourceVal: "Destination",

          bookingSourceText: "Destination"
        }
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",

        ok: "ok"
      },

      allAgentColoader: [],

      packageDetails: [],

      consoMultipleShipperTable: [],

      allShipperData: [],

      CommodityAll: {},

      autoClientName: {},

      totalPackage: "",

      totalPackageVolume: "",

      divideCm: "6000",

      divideInch: "366",

      AirFreightMain: {
        airFcExportId: "",

        cargoId: "",

        shipperFreightId: "",

        jobType: [],

        shipmentType: "Air_Shipment",

        transportType: "Export",

        airportDeparture: "",

        airportDestination: "",

        shipmentExecution: "",

        airFFType: "",

        multipleShipper: "",

        multipleCargo: ""
      },

      airFreightModal: {
        airFcExportId: "",

        cargoId: "",

        shipperFreightId: "",

        clientId: "",

        clientName: "",

        cargoReceivedAt: "",

        bookingSource: "",

        agentName: "",

        sourceOriginclientId: "",

        buyer: "",

        buyingHouse: "",

        otherSpecify: "",

        ccType: "",

        ccCha: "",

        deliveryMode: "",

        doorFpod: "",

        deliveryTerms: "",

        commodityId: "",

        commodityType: "",

        itemDescription: "",

        IMDGClass: "",

        UNNumber: "",

        packingCode: "",

        temperatureRequired: "",

        otherComodity: "",

        specificAdditionalTask: "",

        otherServices: [],

        additionalMoreTask: [],
        typeAirway: "",
        HAWBTerms: "",
        MAWBTerms: "",
        freightTerms: ""
      },

      HAWBTermsError: "",
      MAWBTermsError: "",
      freightTermsError: "",
      AirwayType: [
        {
          value: "HouseAirwayBL",
          text: "House Airway B/L"
        },
        {
          value: "DirectAirwayBL",
          text: "Direct Airway B/L"
        }
      ],
      freightTerms: [
        {
          value: "Prepaid",
          text: "Prepaid"
        },
        {
          value: "Collect",
          text: "Collect"
        }
      ],

      airPackageModal: {
        airFcExportId: "",

        cargoId: "",

        cargoVolumeWeight: "",

        chargeVolWgtSys: "",

        chargeVolWgtAir: "0",

        finalChargableWeight: "",

        cargoGrossWeight: "",

        CargowgtUnit: "Kg",

        clientId: "",

        clientName: "",

        shipperFreightId: "",

        shipperFreightId: "",

        airFcExportId: "",

        noOfPackage: "",

        packageLength: "",

        packageWidth: "",

        packageHeight: "",

        packageUnit: "Cm",

        packageVolume: ""
      },

      deleteId: "",

      shippingIdError: "",

      totalContainer: "",

      noOfContainerError: "",

      containerTypeIdError: "",

      fobReceiptName: "",

      fobLoadPortName: "",

      commodityArray: [],

      getPortData: ["Agra"],

      // clientName: "",

      // vehicleName: "",

      // driverId: "",

      // driverName: "",

      // driverContact: "",

      // driverWorkingYear: "",

      // driverEsic: "",

      // accountNo: "",

      // uploadDriverDoc: ""

      showPackage: false,

      openShipper: false,

      error: {
        clientNameError: "",

        toPortError: "",

        fromPortError: "",

        transhipmentNameError: "",

        addOneTranError: ""
      },

      getCLientData: ["gfdg"],

      getagentName: ["gfdg"],

      showSegmentArray: [],

      showOtherServiceArray: [],

      showAdditionalMoreTaskArray: [],

      packageDetailsTemp: [],

      driverNameDetail: ["iji"],

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",

        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New"
      },

      errorAtleastOne: "",

      // ffExportError: ["Please Select Place of Receipt"],

      // ffExportError: ],

      // ffExportError: ["Please Select Port of Discharge"],

      // ffExportError: ["Please Select Final Place of Delivery"],

      // ffExportError: ["Please Select Commodity"],

      // ffExportError: ["Please Select Shipping Line"],

      ffExportError: [
        "Please Select Client Name",

        "Please Select Place of Receipt",

        "Please Select Load  Port Name",

        "Please Select Port  of Discharge",

        "Please Select final Delievery",

        "Please Select Commidity",

        "Please Select Stuffing type"
      ],

      ffExporterrorList: {
        clientId: "",

        // if(airFreightModal.containerInfo=='fcl'){}

        PORlocationId: "",

        LPlocationId: "",

        PODLocationId: "",

        finalPlaceLocationId: "",

        commodityId: "",

        stuffingType: ""
      },
      mainErrorList: {
        airportDeparture: "",
        airportDestination: "",
        airFFType: "",
        shipmentExecution: ""
      },
      mainError: [
        "Select Departure Airport",
        "Select Arrival Airport",
        "Select FF Activity Type",
        "Select Shipment Execution"
      ],

      shipperErrorList: {
        clientId: "",

        cargoReceivedAt: "",
        typeAirway: "",

        bookingSource: "",
        deliveryMode: "",
        commodityId: ""
      },

      shipperError: [
        "Select Client Name",

        "Select Cargo Received Place",
        "Select Type Airway",

        "Select Booking Source",
        "Select Destination Delivery Mode",
        "Select Commidity"
      ],

      packageError: [
        "Select Client Name",

        "Enter Cargo Gross Weight",

        "Select Weight Unit",

        "Enter Volume Weight By Airline",

        "Enter No. of Package",

        "Enter Package Length",

        "Enter Package width",

        "Enter Package height",

        "Select Unit"
      ],

      packageErrorList: {
        shipperFreightId: "",

        cargoGrossWeight: "",

        CargowgtUnit: "",

        chargeVolWgtAir: "",

        packageLength: "",

        noOfPackage: "",

        packageWidth: "",

        packageHeight: "",

        packageUnit: ""
      },

      getPortDischargeList: [],

      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",

          shipmentTypeText: "Sea Shipment"
        },

        {
          shipmentTypeVal: "Air_Shipment",

          shipmentTypeText: "Air Shipment"
        }
      ],

      jobTypeSelectVal: false,

      otherServicesVal: false,

      getShippingLineData: ["zim"],

      getCommodityData: ["zim"],

      getContainerTypeData: ["zim"],

      getlocationListData: ["agra"],

      getAlllocationListData: ["agra"],

      IcdPOrtList: ["agra"],

      validate: true,

      clientNameError: "",

      addDriverError1: "",

      addTruckError4: "",

      ExecutionDisable: "",

      oldValue: "",

      counter: 0
    };
  },

  mounted() {},

  beforeDestroy() {
    // this.$sessionsStorage.set("editExportFCLId", "");
  },

  destroyed() {},

  components: {
    DatePicker,
    CustomLoader,

    ModelListSelect,
    

    Loading
  },

  computed: {
    commodityList() {
      return this.getCommodityData;
    },

    allLocationList() {
      return this.getAlllocationListData;
    },

    agentNameList() {
      return this.getagentName.filter(x => {
        return x.categoryType == "Agent";
      });
    },
    chaNameList() {
      return this.getagentName.filter(x => {
        return x.categoryType == "CHA";
      });
    },

    clientList() {
      return this.getCLientData;
    },

    packageClientList() {
      return this.consoMultipleShipperTable;
    },

    departureAirportList() {
      return this.departureAirportListName;
    }
  },

  methods: {
    showMoreShipper() {
      if (this.openShipper == false) {
        this.openShipper = true;
      } else {
        this.openShipper = false;
      }
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "air_cargo_detail",
          tableId: "cargoId",
          isActive: "isActiveCargo",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            // this.counter = 0;
            // this.oldValue = "";
            // this.JqueryFun();
            this.getData();
            this.deleteId = "";

            // console.log(data);
          })
          .catch(error => {});
      }
    },
    previousExection() {
      this.$router.push({
        path: "/airfreight/airFreightExecution"
      });
    },

    allFinalWeight() {
      console.log(this.airPackageModal.shipperFreightId);
      if (this.airPackageModal.shipperFreightId != "") {
        if (this.oldValue == "") {
          console.log(
            "fsdf22",
            this.oldValue,
            this.airPackageModal.shipperFreightId,
            this.counter
          );

          this.oldValue = this.airPackageModal.shipperFreightId;
        } else if (this.oldValue == this.airPackageModal.shipperFreightId) {
          console.log(
            "fsdf2211",
            this.oldValue,
            this.airPackageModal.shipperFreightId,
            this.counter
          );
        } else {
          this.counter = 0;

          this.oldValue = this.airPackageModal.shipperFreightId;

          console.log(
            "fsdf444",
            this.oldValue,
            this.airPackageModal.shipperFreightId
          );
        }

        let arrayID = this.consoMultipleShipperTable.filter(x => {
          return x.shipperFreightId == this.airPackageModal.shipperFreightId;
        });

        if (arrayID.length > 0) {
          this.airPackageModal.airFcExportId = arrayID[0].airFcExportId;

          this.airPackageModal.clientId = arrayID[0].clientId;

          this.airPackageModal.clientName = arrayID[0].clientName;
        }

        let arrayNew = this.packageDetailsTemp;

        if (arrayNew.length > 0) {
          let arrayMain = arrayNew.filter(x => {
            return x.shipperFreightId == this.airPackageModal.shipperFreightId;
          });

          if (arrayMain.length > 0) {
            this.totalPackage = 0;

            this.totalPackageVolume = 0;

            arrayMain.map((x, index) => {
              this.totalPackage =
                parseFloat(x.noOfPackage) + parseFloat(this.totalPackage);

              this.totalPackageVolume =
                parseFloat(x.packageVolume) +
                parseFloat(this.totalPackageVolume);

              this.airFreightModal.cargoVolumeWeight = this.totalPackageVolume;
            });

            this.packageDetails = arrayMain;

            if (this.counter == 0) {
              this.airPackageModal.cargoGrossWeight =
                arrayID[0].cargoGrossWeight;

              this.airPackageModal.CargowgtUnit = arrayID[0].CargowgtUnit;

              this.airPackageModal.chargeVolWgtSys = arrayID[0].chargeVolWgtSys;

              this.airPackageModal.chargeVolWgtAir = arrayID[0].chargeVolWgtAir;

              this.airPackageModal.finalChargableWeight =
                arrayID[0].finalChargableWeight;

              this.airPackageModal.cargoVolumeWeight =
                arrayID[0].cargoVolumeWeight;

              this.counter++;
            }
          } else {
            if (this.counter == 0) {
              this.airPackageModal.cargoGrossWeight = "";

              this.airPackageModal.cargoVolumeWeight = "";

              this.airPackageModal.chargeVolWgtAir = "";

              this.airPackageModal.chargeVolWgtSys = "";
              this.airPackageModal.finalChargableWeight = "";
              this.counter++;
            }

            this.packageDetails = [];
          }
        } else {
          this.packageDetails = arrayNew;
        }
      } else {
        this.packageDetails = this.packageDetailsTemp;
      }
    },

    showMoreContainer() {
      if (this.showPackage == false) {
        this.showPackage = true;
      } else {
        this.showPackage = false;
      }
    },

    VolumeWeightBySysAmount() {
      //   if (
      //     parseFloat(this.airFreightModal.cargoGrossWeight) >
      //     parseFloat(this.airFreightModal.cargoVolumeWeight)
      //   ) {
      //     this.airFreightModal.chargeVolWgtSys = this.airFreightModal.cargoGrossWeight;
      //   } else {
      //     this.airFreightModal.chargeVolWgtSys = this.airFreightModal.cargoVolumeWeight;
      //   }
    },

    FinalVolumeWeightAmount() {
      //   if (
      //     parseFloat(this.airFreightModal.chargeVolWgtSys) >
      //     parseFloat(this.airFreightModal.chargeVolWgtAir)
      //   ) {
      //     this.airFreightModal.finalChargableWeight = this.airFreightModal.chargeVolWgtSys;
      //   } else {
      //     this.airFreightModal.finalChargableWeight = this.airFreightModal.chargeVolWgtAir;
      //   }
    },

    VolumeWeightCargoAmount() {
      let newVal =
        this.airPackageModal.packageUnit == "Cm"
          ? this.divideCm
          : this.divideInch;

      let mainVolume =
        (parseFloat(this.airPackageModal.packageLength) *
          parseFloat(this.airPackageModal.packageWidth) *
          parseFloat(this.airPackageModal.packageHeight) *
          parseFloat(this.airPackageModal.noOfPackage)) /
        parseFloat(newVal);

      this.airPackageModal.packageVolume = mainVolume.toFixed(3);
    },

    viewEditShiper(item1) {
      window.scroll(0, 10);

      let arrayOther = [];

      let arrayAdditional = [];

      // console.log(item1);

      let arrayFilterShiper = this.consoMultipleShipperTable.filter(x => {
        return x.shipperFreightId == item1.shipperFreightId;
      });

      Object.keys(this.airFreightModal).map(x => {
        this.airFreightModal[x] = arrayFilterShiper[0][x] || "";

        if (x == "otherServices") {
          arrayOther = arrayFilterShiper[0][x].split(",");
        }

        if (x == "additionalMoreTask") {
          arrayAdditional = arrayFilterShiper[0][x].split(",");
        }
      });

      this.airFreightModal["otherServices"] = [];

      this.airFreightModal["additionalMoreTask"] = [];

      this.showOtherServiceArray.map((x, index) => {
        let i = arrayOther.indexOf(x.value);

        i >= 0
          ? (this.airFreightModal.otherServices[index] = true)
          : (this.airFreightModal.otherServices[index] = false);
      });

      this.showAdditionalMoreTaskArray.map((x, index) => {
        let iA = arrayAdditional.indexOf(x.value);

        iA >= 0 ? this.airFreightModal.additionalMoreTask.push(x) : "";
      });

      this.getData();
    },

    viewEditPackage(item1) {
      this.showPackage = true;

      this.counter = 0;

      // console.log(item1);

      Object.keys(this.airPackageModal).map(x => {
        this.airPackageModal[x] = item1[x] || "";
      });
    },

    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.AirFreightMain.jobType = Array(
            this.showSegmentArray.length
          ).fill(true);

          this.jobTypeSelectVal = true;
        } else {
          this.AirFreightMain.jobType = Array(
            this.showSegmentArray.length
          ).fill(false);

          this.jobTypeSelectVal = false;
        }
      }
    },

    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.airFreightModal.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);

          this.otherServicesVal = true;
        } else {
          this.airFreightModal.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);

          this.otherServicesVal = false;
        }

        this.getServicesData();
      }
    },

    validatePackage() {
      let validate_new = true;

      Object.keys(this.packageErrorList).map((x, index) => {
        if (this.airPackageModal[x] == "") {
          this.packageErrorList[x] = this.packageError[index];

          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    validateShipper() {
      let validate_new = true;

      Object.keys(this.shipperErrorList).map((x, index) => {
        if (this.airFreightModal[x] == "") {
          this.shipperErrorList[x] = this.shipperError[index];

          validate_new = false;
        }
      });

      if (
        this.airFreightModal.HAWBTerms == "" &&
        this.airFreightModal.typeAirway == "HouseAirwayBL"
      ) {
        this.HAWBTermsError = "Select HAWB Terms";
        validate_new = false;
      } else {
        this.HAWBTermsError = "";
      }

      if (
        this.airFreightModal.MAWBTerms == "" &&
        this.airFreightModal.typeAirway == "HouseAirwayBL"
      ) {
        this.MAWBTermsError = "Select HAWB Terms";
        validate_new = false;
      } else {
        this.MAWBTermsError = "";
      }

      if (
        this.airFreightModal.freightTerms == "" &&
        this.airFreightModal.typeAirway == "DirectAirwayBL"
      ) {
        this.freightTermsError = "Select HAWB Terms";
        validate_new = false;
      } else {
        this.freightTermsError = "";
      }
      Object.keys(this.mainErrorList).map((x, index) => {
        if (this.AirFreightMain[x] == "") {
          this.mainErrorList[x] = this.mainError[index];

          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addMainWithShipper() {
      let newVal = [];

      let newValOther = [];

      let newAdditionalTask = [];

      this.showSegmentArray.map((x, index) => {
        if (this.AirFreightMain.jobType[index] == true) {
          newVal.push(x.value);
        }
      });

      this.showOtherServiceArray.map((x, index) => {
        if (this.airFreightModal.otherServices[index] == true) {
          newValOther.push(x.value);
        }
      });

      if (this.airFreightModal.additionalMoreTask.length > 0) {
        this.airFreightModal.additionalMoreTask.map((x, index) => {
          newAdditionalTask.push(x.value);
        });
      }

      this.AirFreightMain["jobType"] = newVal;

      this.airFreightModal["otherServices"] = newValOther;

      this.airFreightModal["additionalMoreTask"] = newAdditionalTask;

      let newData = {
        FCLAIRMAIN: this.AirFreightMain,

        FCLAIRShipper: this.airFreightModal,

        onlyExecMain: "fdsgdsgf"
      };
      this.validateShipper();

      if (this.validate != false) {
        // $("#addButtonLoader1").css("display", "none");

        // $("#loader1").css("display", "block");

        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/addAirShipperAndMain.php`,

          data: JSON.stringify(newData),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const {
              statusText,

              status,

              data
            } = result;

            //  console.log(result);

            if ( status == 200 && data) {
              //   $("#loader1").css("display", "none");

              //   $("#addButtonLoader1").css("display", "block");

              // if (data.msg == "Inserted Successfully") {

              //   this.alert.content = "Data Added Successfully";

              // } else {

              //   this.alert.content = "Data Updated Successfully";

              //   this.$refs["addPop"].open();

              // }

              if (this.AirFreightMain.airFcExportId == "") {
                this.$sessionsStorage.set(
                  "editffAirExport",

                  data.airFcExportId
                );

                this.AirFreightMain.airFcExportId = data.airFcExportId;
              }

              if (this.AirFreightMain.airFFType == "fclNormal") {
                this.airFreightModal.shipperFreightId = data.shipperFreightId;
              }

              Object.keys(this.airFreightModal).map(x => {
                if (x == "otherServices" || x == "additionalMoreTask") {
                  this.airFreightModal[x] = [];
                } else {
                  this.airFreightModal[x] = "";
                }
              });

              this.getData();
              this.openShipper = false;
            }
          })

          .catch(error => {});
      }
    },

    DeleteList(id) {
      console.log(id);
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    addPackage() {
      this.validatePackage();

      if (this.validate != false) {
        $("#addButtonLoaderpackage").css("display", "none");

        $("#loaderpackage").css("display", "block");

        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/addPackageAirFF.php`,

          data: JSON.stringify(this.airPackageModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const {
              statusText,

              status,

              data
            } = result;

            //  console.log(result);

            if ( status == 200 && data) {
              console.log(data);

              $("#loaderpackage").css("display", "none");

              $("#addButtonLoaderpackage").css("display", "block");

              Object.keys(this.airPackageModal).map(x => {
                this.airPackageModal[x] = "";
              });

              this.getData();
              this.oldValue = "";
              this.counter = 0;

              this.showPackage = false;
            }
          })

          .catch(error => {});
      }
    },

    proceedBooking() {
      let newVal = [];

      this.showSegmentArray.map((x, index) => {
        if (this.AirFreightMain.jobType[index] == true) {
          newVal.push(x.value);
        }
      });

      this.AirFreightMain["jobType"] = newVal;

      //  this.validatePackage();

      if (this.validate != false) {
        $("#addButtonLoaderpro").css("display", "none");

        $("#loaderpro").css("display", "block");

        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/updateMainFFDetails.php`,

          data: JSON.stringify(this.AirFreightMain),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const {
              statusText,

              status,

              data
            } = result;

            //  console.log(result);

            if ( status == 200 && data) {
              console.log(data);

              this.$sessionsStorage.set("editAirBookingId", data.airBookingId);

              $("#loaderpro").css("display", "none");

              $("#addButtonLoaderpro").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";

                this.$refs["addPop"].open();
              }

              this.getData();
            }
          })

          .catch(error => {});
      }
    },

    goToBookingPage() {
      this.$router.push({
        path: "/airfreight/airFreightBooking"
      });
    },

    updateCargo() {
      //  this.validatePackage();

      if (this.validate != false) {
        // $("#addButtonLoaderUpdate").css("display", "none");

        // $("#loaderUpdate").css("display", "block");

        let options = {
          method: "POST",

          url: `${URL_BASE}/Api_AirExport/updateShiperCargoDetails.php`,

          data: JSON.stringify(this.airPackageModal),

          crossDomain: true,

          headers: {
            Accept: "application/json",

            "Content-Type": "application/json",

            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const {
              statusText,

              status,

              data
            } = result;

            //  console.log(result);

            if ( status == 200 && data) {
              console.log(data);

              // $("#loaderUpdate").css("display", "none");

              // $("#addButtonLoaderUpdate").css("display", "block");

              this.counter = 0;

              this.getData();

              this.showPackage = false;
            }
          })

          .catch(error => {});
      }
    },

    CommodityCallback(item) {
      // console.log(item);

      this.airFreightModal.commodityId = item.commodityId;

      this.airFreightModal.commodityType = item.commodityType;

      this.airFreightModal.itemDescription = item.itemDescription;

      //  console.log(this.ffFclConsoModel.commodityType, "jitu");
    },

    doLoading() {
      this.isLoading = true;

      // simulate AJAX
    },

    doLoadingClose() {
      this.isLoading = true;

      // simulate AJAX

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    showMultiple() {
      this.airFreightModal.additionalMoreTask.map(x => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;

          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getData() {
      let array = [];

      let arrayAdditional = [];

      this.doLoading();

      let vehicle_drive = {
        itemCode: "itemCode",

        airFcExportId:
          this.$sessionsStorage.get("editffAirExport") != "" &&
          this.$sessionsStorage.get("editffAirExport") != undefined
            ? this.$sessionsStorage.get("editffAirExport")
            : ""
      };

      let options = {
        method: "POST",

        url: `${URL_BASE}/Api_AirExport/getDataFCLMainAir.php`,

        data: JSON.stringify(vehicle_drive),

        crossDomain: true,

        headers: {
          Accept: "application/json",

          "Content-Type": "application/json",

          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const {
            statusText,

            status,

            data
          } = result;

          if ( status == 200 && data) {
            console.log(data, "ddsdsds");
            if (data.airFreightDetail.length > 0) {
              Object.keys(this.AirFreightMain).map(x => {
                this.AirFreightMain[x] = data.airFreightDetail[0][x] || "";

                if (x == "jobType") {
                  array = data.airFreightDetail[0][x].split(",");
                }
              });

              this.AirFreightMain["jobType"] = [];

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                // console.log(array, i);

                i >= 0
                  ? (this.AirFreightMain.jobType[index] = true)
                  : (this.AirFreightMain.jobType[index] = false);
              });
            }

            if (data.shipperDetail.length > 0) {
              this.allShipperData = data.shipperDetail;
            } else {
              this.allShipperData = [];
            }

            if (data.shipperDetail.length > 0) {
              this.consoMultipleShipperTable = data.shipperDetail;
            } else {
              this.consoMultipleShipperTable = [];
            }

            if (data.packageDetailCargo.length > 0) {
              this.packageDetails = data.packageDetailCargo;

              this.packageDetailsTemp = data.packageDetailCargo;
            } else {
              this.packageDetails = [];
              this.packageDetailsTemp = [];
            }

            if (data.CommodityData.length > 0) {
              this.getCommodityData = data.CommodityData;
            }

            //  console.log(data);

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            // let newLocation = data.LocationDetails;

            if (data.LocationDetails.length > 0) {
              this.getAlllocationListData = data.LocationDetails;
            }

            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData;
            }

            this.doLoadingClose();

            setTimeout(() => {
              this.allFinalWeight();
            }, 2500);

            this.JqueryFun();
          }
        })

        .catch(error => {});
    },

    addNew() {
      //   this.$router.push({
      //     path: "/client/addClient"
      //   });
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "Freight_Forwarding",

          show: "Freight Forwarding(FF)",

          flex: "20"
        },

        {
          value: "Customs_Clearance",

          show: "Customs Clearance(CC)",

          flex: "20"
        },

        {
          value: "Transportation",

          show: "Transportation(TPT)",

          flex: "20"
        },

        {
          value: "All",

          show: "All",

          flex: "15"
        }

        // {

        //   value: "None",

        //   show: "None",

        //   flex: "15"

        // },
      ];

      this.showOtherServiceArray = [
        {
          value: "Marking",

          show: "Marking/Labelling",

          flex: "20"
        },

        {
          value: "Palletization",

          show: "Palletization",

          flex: "15"
        },

        {
          value: "Fumigation",

          show: "Fumigation",

          flex: "15"
        },

        {
          value: "Lashing",

          show: "Lashing/Choking",

          flex: "15"
        },

        {
          value: "None",

          show: "None",

          flex: "15"
        }

        // {

        //   value: "None",

        //   show: "None",

        //   flex: "15"

        // },
      ];

      this.showAdditionalMoreTaskArray = [
        {
          value: "Legalization",

          show: "Legalization"
        },

        {
          value: "COC_GSP",

          show: "COC/GSP"
        },

        {
          value: "Phyto",

          show: "Phyto"
        },

        {
          value: "APEDA",

          show: "APEDA"
        },

        {
          value: "HealthCertificate",

          show: "Health Certificate"
        },

        {
          value: " WildlifeNOC",

          show: " Wildlife NOC"
        },

        {
          value: "OthersSpecify",

          show: " Others Specify"
        }

        // {

        //   value: "None",

        //   show: "None",

        //   flex: "15"

        // },
      ];

      // this.airFreightModal.otherServices[0] = true;
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// updatePackageExection.vue?dd454dbc